import { useQuery } from "@tanstack/react-query";

import { type ClientSurvey } from "@fitness-app/data-models/entities/ClientSurvey";

import { traineeKeys, useTraineeId } from "~/modules/Trainee/TraineeProfile/scope";
import { supabase } from "~/store/initializeStore";

// To samo co `fetchTraineeSurveys({ traineeId })` (panel trenera: wszystkie ankiety, bez filtra).
export const useTraineeSurveys = () => {
  const traineeId = useTraineeId();

  return useQuery({
    queryKey: traineeKeys.surveys(traineeId),
    queryFn: async () => {
      const { data, error } = await supabase
        .from("client_survey")
        .select("*")
        .eq("traineeId", traineeId)
        .order("createdAt", { ascending: false })
        .returns<ClientSurvey[]>();

      if (error) {
        throw new Error(error.message);
      }

      return data;
    },
  });
};
